/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetAccountSettingsResponse } from '../models/GetAccountSettingsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountSettingsService {
    /**
     * Retrieves the account settings.
     * This endpoint returns the configured account settings, including password policies and security requirements.
     * @returns GetAccountSettingsResponse Successfully retrieved account settings.
     * @throws ApiError
     */
    public static getAccountSettingsEndpoint(): CancelablePromise<GetAccountSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/account/settings',
            errors: {
                500: `Internal server error occurred while retrieving settings.`,
            },
        });
    }
}
